/**
 * Public marketing pages served on the main domain.
 * Everything else (restaurant dashboards, /login, /:slug/... etc.) keeps going to the app.
 */
export type MarketingPage = 'home' | 'get-started' | 'support' | 'privacy' | 'terms';

export const marketingRoutes: Record<MarketingPage, { path: string; file: string }> = {
  home: { path: '/', file: 'home.html' },
  'get-started': { path: '/get-started', file: 'get-started.html' },
  support: { path: '/support', file: 'support.html' },
  privacy: { path: '/privacy', file: 'privacy.html' },
  terms: { path: '/terms', file: 'terms.html' },
};

export function marketingPageFor(pathname: string): MarketingPage | null {
  const clean = pathname.replace(/\.html$/, '').replace(/\/+$/, '') || '/';
  if (clean === '/home') return 'home';
  for (const [page, route] of Object.entries(marketingRoutes) as [MarketingPage, { path: string }][]) {
    if (route.path === clean) return page;
  }
  return null;
}
